import { ReactNode } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Paper } from '@shared/components';

interface Props {
  id: string;
  headingId: string;
  title: ReactNode;
  closeLabel: string;
  onClose: () => void;
  children: ReactNode;
}

export const KeyFiguresDetailPanel = ({
  id,
  headingId,
  title,
  closeLabel,
  onClose,
  children,
}: Props) => (
  <Paper id={id} role="region" aria-labelledby={headingId} sx={{ p: 2.5, borderRadius: 2 }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} mb={2}>
      <Typography id={headingId} component="h3" variant="subtitle1" fontWeight={700}>
        {title}
      </Typography>
      <IconButton size="small" onClick={onClose} aria-label={closeLabel}>
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    </Stack>
    {children}
  </Paper>
);
